export default __webpack_public_path__ + "static/media/pm.f902960a.png";